module.exports = __webpack_public_path__ + "src/assets/img/s-sensors.bde83fab.svg";